export default __webpack_public_path__ + "static/media/ic_bottom_tab_homework.5a1281a2.svg";